export const isNumeric = (value: any): boolean => {
  return typeof value === 'string' && /^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(value) && isFinite(Number(value))
}
